import { Modal, AsyncSelect } from "components";
import { Button } from "expano-components";
import { useCallback, useMemo, useState } from "react";

import getAllProducts from "utils/select_options/getAllProducts";

const AddProduct = ({ handleClose, handleConfirm }) => {
  const [choosed_products, setChoosedProducts] = useState([]);

  const handleSetChoosedProducts = useCallback(
    (product) => {
      if (
        product.value &&
        !choosed_products.find(({ value }) => value === product.value)
      ) {
        setChoosedProducts([...choosed_products, product]);
      }
    },
    [choosed_products],
  );

  const handleUnSetChoosedProducts = useCallback(
    (product) => {
      setChoosedProducts(
        choosed_products.filter(({ value }) => value !== product.value),
      );
    },
    [choosed_products],
  );

  const product_ids = useMemo(
    () => choosed_products.map(({ value }) => value),
    [choosed_products],
  );

  return (
    <Modal
      size="md"
      handleClose={handleClose}
      header={{
        title: "Dodaj produkty",
      }}
      footer={
        <>
          <Button type="cancel" onClick={handleClose} />
          <Button
            type="add-green"
            disabled={!product_ids.length}
            text="Dodaj"
            onClick={() => handleConfirm(product_ids)}
          />
        </>
      }
    >
      <AsyncSelect
        label="Wybierz produkt, który chcesz dodać do kampanii"
        getData={(q) => getAllProducts(q)}
        onChange={(item) => handleSetChoosedProducts(item)}
      />
      <p>Produkty do dodania:</p>
      <ul className="simple-list">
        {choosed_products.map((item) => (
          <li key={item.value}>
            <p className="df v-center gap-10">
              <span>{item.label}</span>
              <Button
                type="delete-bin"
                onClick={() => handleUnSetChoosedProducts(item)}
              />
            </p>
          </li>
        ))}
      </ul>
    </Modal>
  );
};

export default AddProduct;
